import HttpV2 from './HttpV2';

class SupportSubmissionServiceV2 {
  static async createSubmission(payload) {
    return HttpV2.post(`support-submissions`, payload);
  }
}

export default SupportSubmissionServiceV2;
